// skipcq: JS-W1028
import { useCallback } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';

import PintPortfolioGrid from '../../components/pintPortfolio/PintPortfolioGrid';
import useBeerReviewTags from '../../hooks/useBeerReviewTags';
import {
  trackPintPortfolioClickViewDetails,
} from '../../utils/brewhousePortalAnalytics';

function PintPortfolioPage() {
  const navigate = useNavigate();
  const { tagLabelMap } = useBeerReviewTags();
  const {
    breweryId,
    gridBeers,
    catalogLoading,
    catalogError,
    searchLoading,
    styleMetaMap,
    breweryNameById = {},
    focusBeerId = '',
    clearFocusBeerId = null,
  } = useOutletContext();

  const handleViewDetails = useCallback(
    (beer) => {
      if (!breweryId || !beer?.id) {
        return;
      }
      try {
        trackPintPortfolioClickViewDetails({
          breweryId,
          beerId: beer.id,
        });
      } catch {
        // Navigation must succeed even when analytics capture fails.
      }
      navigate(`/brewery-portal/pint-portfolio/${beer.id}`);
    },
    [breweryId, navigate],
  );

  return (
    <PintPortfolioGrid
      beers={gridBeers}
      loading={catalogLoading}
      error={catalogError}
      searchLoading={searchLoading}
      styleMetaMap={styleMetaMap}
      tagLabelMap={tagLabelMap}
      breweryNameById={breweryNameById}
      onViewDetails={handleViewDetails}
      focusBeerId={focusBeerId}
      onFocusBeerHandled={clearFocusBeerId}
    />
  );
}

export default PintPortfolioPage;
